module.exports = "<div class=\"uim-widget uim-user-profile\"><a href=\"\" id=uim-user-profile-link></a><div class=uim-user-profile-container><div id=uim-user-profile class=uim-user-profile-popup><img id=uim-user-profile-close class=uim-popup-close src=" + require("../../../user-profile/src/style/close.svg") + "></div></div></div>";


//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/html/UserProfile.html
// module id = 26
// module chunks = 0